import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";
import { useTranslationNamespace, LgTranslatePipe } from "@logex/framework/lg-localization";
import { NgIf } from "@angular/common";
import {
    LgLongTextDirective,
    LgIconComponent,
    LgSimpleTooltipDirective,
    LgSnackbarService
} from "@logex/framework/ui-core";

@Component({
    selector: "text-clipboard-copy",
    templateUrl: "./text-clipboard-copy.component.html",
    styleUrls: ["./text-clipboard-copy.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [useTranslationNamespace("APP._Shared")],
    standalone: true,
    imports: [LgLongTextDirective, NgIf, LgIconComponent, LgSimpleTooltipDirective, LgTranslatePipe]
})
export class TextClipboardCopyComponent {
    private _snackbar = inject(LgSnackbarService);

    text = input("");

    copied = false;

    _copyText(event: Event): void {
        event.stopPropagation();
        navigator.clipboard.writeText(this.text());

        this._snackbar.show({
            titleLc: "APP._Shared.TextCopied",
            hideCloseButton: true,
            delayHide: 2000
        });
    }
}
